import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
  DashboardView,
  Program,
  Notifications,
  NotificationHead,
  Certificate,
  Attendance,
} from "modules";
import { PageNotFound } from ".";
import {
  MainFooter,
  MainHeader,
  GlobalErrorHandler,
  HeaderRightBlock,
} from "shared";
import { AttendanceScope, QuestionnaireScope } from "master";
import { getSelectedProgram, getTokens, getUniqueDeviceId } from "utils";
import { useImmer } from "use-immer";
import { useActivityLog } from "@nergy-ui/practicetool";

export const Home = () => {
  const location = useLocation();
  const [studentBatchId, setStudentBatchId] = useImmer(null);
  const [isActivityLogNeeded, setIsActivityLogNeeded] = useImmer(false);

  const localStorageTask = sessionStorage.getItem("currentTask")
    ? JSON.parse(sessionStorage.getItem("currentTask"))
    : null;

  const localStorageCourseId = sessionStorage.getItem("courseId")
    ? JSON.parse(sessionStorage.getItem("courseId"))
    : null;

  const isCourseListPage = location.pathname.includes("/courseslist/");

  const isQuestionnaire =
    location.pathname === "/program/assessment/start" ||
    location.pathname === "/program/assessment/review" ||
    location.pathname === "/program/assessment/result" ||
    location.pathname === "/program/assessment/allQuestions";

  const tokens = getTokens();
  const deviceId = getUniqueDeviceId();
  const apiSetting = {
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    apiEndpoint: `api/v2/portal/activity-logs`,
    configEndpoint: `api/v2/portal/activity-logs/${studentBatchId}/config`,
    sessionEndPoint: `api/v2/portal/activity-logs/session`,
    headers: {
      Authorization: `Bearer ${tokens?.token}`,
      DeviceId: deviceId,
    },
  };

  const { sendDataToBackend } = useActivityLog({
    studentBatchId,
    courseId: isCourseListPage ? localStorageCourseId : null || null,
    courseTaskId: isCourseListPage
      ? localStorageTask?.courseTaskId
      : null || null,
    apiSetting,
    isActivityLogNeeded: !!studentBatchId && isActivityLogNeeded,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (location.pathname.startsWith("/program")) {
      setIsActivityLogNeeded(true);
      const selectedProgram = getSelectedProgram();
      const studentBatchId = selectedProgram?.studentBatchId;
      setStudentBatchId(studentBatchId || null);
    } else {
      setIsActivityLogNeeded(false);
      sendDataToBackend();
    }
  }, [location.pathname]);

  return (
    <div>
      <div id="main" className="layout-navbar">
        <div id="main-content">
          <QuestionnaireScope>
            <GlobalErrorHandler>
              {location.pathname === "/" && <NotificationHead />}
              <MainHeader>
                <HeaderRightBlock />
              </MainHeader>
              <AttendanceScope>
                <Routes>
                  <Route element={<DashboardView />} path={"/"} />
                  <Route element={<DashboardView />} path={"/account-delete"} />
                  <Route element={<Program />} path="/program/*" />
                  <Route element={<PageNotFound />} path={"/*"} />
                  <Route element={<Notifications />} path={"/notifications"} />
                  <Route
                    element={<Certificate isAllCertificate={true} />}
                    path={"/certificate/*"}
                  />
                  <Route element={<Attendance />} path={"/attendance/*"} />
                </Routes>
              </AttendanceScope>

              {!isQuestionnaire && <MainFooter />}
            </GlobalErrorHandler>
          </QuestionnaireScope>
        </div>
      </div>
    </div>
  );
};
